import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Outsourcing / Contractual / Adhoc Employee Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Outsourcing / Contractual / Adhoc Employee Committee</h3>
                                <p className='caboutus c-lineheight2dot5'> The Outsourcing / Contractual / Adhoc Employee Appointment Committee of the Institute is reconstituted with the following members:  </p>

                                {/* <Link className='c-link' to="icc@iittp.ac.in" target="_blank" >icc@iittp.ac.in </Link> */}

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dean, Administration & Finance</p>
                                                <p></p>
                                            </td>
                                            <td>Chairman</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Registrar</p>
                                                <p></p>
                                            </td>
                                            <td> Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p> Dean/HoD/HoS of the concerned Department/Section</p>
                                                <p></p>
                                            </td>
                                            <td> Expert Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p> HoD/HoS of the concerned Department/Section</p>
                                                <p></p>
                                            </td>
                                            <td> Expert Member (as necessary)</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p> Assistant Registrar, General Administration</p>
                                                <p> </p>
                                            </td>
                                            <td>Member Secretary</td>
                                        </tr>

                                                                               
                                    </tbody>

                                </Table>
                                <p className='caboutus c-lineheight2dot5'> The Committee is responsible for streamlining all matters relating to Outsourcing/Contractual/Adhoc employees, which includes recruitment, appointment, and other applicable terms and conditions, engaged under various funding heads such as Institute, CSRC, Student Affairs, Library and any other similar funds.</p>
                                <p className='caboutus c-lineheight2dot5'> All other committees dealing with matters pertaining to Outsourcing/Contractual/Adhoc employees, other than this Committee, shall stand discontinued with immediate effect.</p>
                                <p className='caboutus c-lineheight2dot5'> The Committee may invite any officer(s)/expert(s), as deemed necessary, for the effective discharge of its functions.</p>
                                

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;